__webpack_require__.p = "/memory-game-rick-and-morty/";